import { IServerSideGetRowsParams, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import AgGrid from "components/UI/AgGrid";
import { GraphQLClient } from "graphql-request";
import { RefObject, useEffect } from "react";
import { createGraphQLClientWithMiddleware } from "services/graphqlClient";
import { BILLING_NOTE_BY_ITEM_REPORT } from "services/Sales/Report/BillingNoteReportViewsAggrid";
import { useBillingNoteByItemReportColumnDefs } from "./columnDefs";
import CustomizedBoxTable from "components/Custom/CustomizedBoxTable";

interface Props {
  gridRef: RefObject<AgGridReact>;
  height?: string | number;
}

const BillingNoteByItemReportTable = ({ gridRef, height }: Props) => {
  const graphQLClientWms: GraphQLClient = createGraphQLClientWithMiddleware("sales");
  const columnDefs = useBillingNoteByItemReportColumnDefs();
  const datasource = {
    async getRows(params: IServerSideGetRowsParams) {
      const { request } = params;
      const { startRow, endRow, filterModel, sortModel } = request;
      const formatFilter = {
        ...filterModel,
      };
      const formatSort = [
        ...sortModel,
      ];
      try {
        const { BillingNoteByItemReportViewsAggrid } = await graphQLClientWms.request(
          BILLING_NOTE_BY_ITEM_REPORT,
          {
            aggridInput: {
              startRow,
              endRow,
              filterModel: formatFilter,
              sortModel: formatSort,
            },
          }
        );
        params.success({
          rowData: BillingNoteByItemReportViewsAggrid.results,
          rowCount: BillingNoteByItemReportViewsAggrid.count,
        });
      } catch (err) {
        params.fail();
      }
    },
  };

  const onGridReady = (params: GridReadyEvent) => {
    params.api.onFilterChanged();
    params.api.setServerSideDatasource(datasource);
  };

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
    }
  }, [gridRef]);

  return (
    <CustomizedBoxTable height={height}>
      <AgGrid
        ref={gridRef}
        columnDefs={columnDefs}
        // height={670}
        onGridReady={onGridReady}
      />
    </CustomizedBoxTable>
  );
};

export default BillingNoteByItemReportTable;